import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { DomSanitizer } from '@angular/platform-browser';
import { UtilService } from 'src/modules/base/services/util.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { LoginServiceService } from '../service/login-service.service';
import { SmartModalService } from 'src/modules/base/services/smart-modal.service';
import { DynamicPopUpComponent } from 'src/modules/base/components/data-grid/dynamic-pop-up/dynamic-pop-up.component';
import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { PaymentStatusComponent } from 'src/modules/kx-shared/components/payment-status/payment-status.component';
import { AuthenticationService } from 'src/modules/base/shared/services/authentication.service';
import { StorageService } from 'src/modules/base/shared/services/storage.service';

@Component({
  selector: 'app-online-payment-guest',
  templateUrl: './online-payment-guest.component.html',
  styleUrls: ['./online-payment-guest.component.scss'],
  standalone: false
})
export class OnlinePaymentGuestComponent {
  timer: number;
  headerInfo: any = {};
  showTimer: boolean = false;
  disableOtp: boolean = false;
  show: boolean = false;
  eye: string = "fa-eye";
  eye1: string = "fa-eye";
  submitted = false;
  forgotPasswordForm: FormGroup;
  ResetsetOpt: any = false;
  isKarexpert: string = '';
  checkPattern: any = '^[a-zA-Z0-9!@#$&()\\-`.+_,/\"-]*$'
  showOtpComponent: boolean = false;
  @ViewChild('changeOtpBtn') changeOtpBtn: any;
  loginInfo: any = {};
  loggedIn: boolean
  searchPatientDataSource: any
  patientData: any = [];
  patientFields = [
    {
      "heading": "field.label.uhid",
      "card_tag": null,
      "order": 1,
      "sortable": true,
      "name": "uhId"
    },
    {
      "heading": "field.label.age/gender",
      "card_tag": null,
      "order": 2,
      "sortable": true,
      "type": "composite",
      "name": "patient_age,patient_gender",
      "format": "(item) => `${item.patient_age}/${item.patient_gender}`"
    },
    {
      "heading": "field.label.ip_no",
      "card_tag": null,
      "order": 3,
      "sortable": true,
      "name": "admissionId"
    },
    {
      "heading": "field.label.admission_date/time",
      "card_tag": null,
      "order": 4,
      "sortable": true,
      "type": "date",
      "name": "admission_date_gmt"
    },
    {
      "heading": "field.label.net_amount",
      "card_tag": null,
      "order": 5,
      "sortable": true,
      "name": "total_amount"
    },
    {
      "heading": "field.label.due_amount",
      "card_tag": null,
      "order": 6,
      "sortable": true,
      "name": "patient_due_amount"
    },
    {
      "heading": "",
      "type": "multiple_action",
      "setting": true,
      "order": 7,
      // "array": [
      //   {
      //     "type": "action",
      //     "delete": false,
      //     "edit": true,
      //     "toolTip": "field.label.online_payment"
      //   }
      // ]
    }
  ]
  bannerJson: { selector: string; datasource: { application: string; resource: string; query_id: string; }; };
  dialog: any;
  sessionTimer: number;

  constructor(
    private alertService: AlertsService,
    private smartModalService: SmartModalService,
    private baseService: BaseService,
    private router: Router,
    private aroute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private appService: AppService,
    private domSanitizer: DomSanitizer,
    private sanitizer: DomSanitizer,
    public utilService: UtilService,
    private loader: LoaderService,
    private modal: BsModalService,
    private loginService: LoginServiceService,
    private auth: AuthenticationService,
    private storageService: StorageService,
  ) {
    this.loginService.initService()
  }

  ngOnInit() {
    if (this.router.url.indexOf('online-payment/link') > -1) {
      this.timerFn()
      this.loggedIn = true;
      this.searchPatientDataSource = {
        "complex_search": [
          {
            "label": "field.label.uhid",
            "key": "uhId"
          },
          {
            "label": "field.label.ip_no",
            "key": "admissionId"
          }
        ],
        "datasource": {
          "application": "billing",
          "resource": "billing_details",
          "query_id": "GET_BILLING_DETAILS_FOR_PAYMENT",
          "projectionKeys": [
            "patient_name",
            "patient_gender_id",
            "admissionId",
            "admission_date_gmt",
            "patient_due_amount",
            "total_amount",
            "facility_id",
            "id",
            "uhId",
            "telecom",
            "patient_age",
            "patient_gender"
          ],
          "args": "noCount:1",
          "template": "<div class='u-search-items position-relative border-bottom pl-3 pr-3 pb-1 pt-1'><div class='u-name'><span>!!!patient_name!!!</span></div><span class='u-uhid txt-13 pl-2'>!!!uhId!!!</span><span class='u-age txt-13 pl-2'>!!!patient_age!!!</span></div>"
        },
        "capitalise": true,
        "fields": [
          "patient_name",
          "patient_gender_id",
          "admissionId",
          "admission_date_gmt",
          "patient_due_amount",
          "total_amount",
          "telecom",
          "uhId",
          "patient_age",
          "patient_gender"
        ]
      }
    }
    else {
      this.headerInfo = this.appService.getAppHeader();
      this.headerInfo.login_tag = this.headerInfo.login_tag.changingThisBreaksApplicationSecurity == undefined ? this.sanitizer.bypassSecurityTrustHtml(this.headerInfo.login_tag) : this.headerInfo.login_tag;
      if (this.headerInfo.android_app_url != undefined) {
        this.headerInfo.android_app_url = this.domSanitizer.bypassSecurityTrustUrl(this.headerInfo.android_app_url);
      }
      if (this.headerInfo.ios_app_url != undefined) {
        this.headerInfo.ios_app_url = this.domSanitizer.bypassSecurityTrustUrl(this.headerInfo.ios_app_url);
      }
      if (window.location.hostname.substring(0, window.location.hostname.indexOf('.')) != 'karexpert' && window.location.hostname != 'localhost') {
        this.forgotPasswordForm = this.formBuilder.group({
          mob: ['', Validators.required],
          user_name: ['', Validators.required],
          email: ['', null],
          account_id: [window.location.hostname],
        });
      } else {
        this.isKarexpert = 'karexpert';
        this.forgotPasswordForm = this.formBuilder.group({
          mob: ['', Validators.required],
          user_name: ['', Validators.required],
          email: ['', null],
          account_id: ['', Validators.required]
        });
      }
      this.disableOtp = true;
    }
  }

  get lf() { return this.forgotPasswordForm.controls; } // return form
  otp: string;
  // showOtpComponent = true;
  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      'width': '40px',
      'height': '40px'
    }
  };

  clear() {
    this.ResetsetOpt = true;
  }

  ngAfterViewInit() {
    this.aroute.queryParams.subscribe((res: any) => {
      if (res.hasOwnProperty('orderId') || res.hasOwnProperty('admissionId')) {
        let newRes = { ...res, showReciept: true }
        let filter = {
          search_columns: 'admissionId',
          searchColumns: 'admissionId',
          search: res.admissionId,
          page_size: 10,
          page_no: 0,
          args: 'noCount:1,facility_id:' + localStorage.getItem('facility_id')
        }
        this.baseService.getData(filter, "", "deposit", "payment", "GET_DEPOSIT_ON_ADMISSIONID").subscribe((res) => {
          if (res && res.resource && res.resource.length > 0) {
            let menuObj = {
              actionType: {
                "key": "id",
                "action": "print",
                "label": "button.print",
                "file_data": {
                  "application": "payment",
                  "template": "advanceReceipt",
                  "resource": "deposit",
                  "query_id": "GET_DEPOSIT_VALUES_FOR_PRINT",
                  "args": "uhid:!!!uhId!!!,recipt_no:!!!recipt_no!!!,primaryKeyIdentifier:!!!recipt_no!!!,admission_id:!!!admissionId!!!,reportTemplateId:advanceReceipt",
                  "file_type": "pdf"
                },
              },
              data: res.resource[0]
            }
            newRes['menuObj'] = menuObj
          }
        })
        this.showPaymentPopUp(newRes);
      }
    })
  }

  generateOTP() {
    this.loader.showSpinner()
    this.submitted = true;
    // stop here if form is invalid
    if (this.forgotPasswordForm.invalid) {
      this.loader.hideSpinner()
      return;
    }
    let account_url: string = ''
    if (this.isKarexpert != '') {
      account_url = this.forgotPasswordForm.controls['account_id'].value;
    } else {
      account_url = window.location.hostname;
    }

    let args = 'mob:' + this.forgotPasswordForm.value.mob + ',account_url:' + this.forgotPasswordForm.value.account_id + ',name:' + this.forgotPasswordForm.value.user_name + ',type:' + this.forgotPasswordForm.value.email;
    this.baseService.get('SEND_PAYMENT_USER_OTP', args, 'send_otp', 'account-management').subscribe(res => {
      this.loader.hideSpinner()
      if (res.errCode == -1) {
        this.alertService.error(res.message);
      } else if (res.errCode == 0) {
        this.showOtpComponent = true;
        this.alertService.success('Success', res.message);
        this.timer = 59;
        this.showTimer = true;
        let timerInterval = setInterval(() => {
          this.timer -= 1;
          if (this.timer <= 0) {
            clearInterval(timerInterval);
            this.showTimer = false;
          }
        }, 1000)
      }
    })
  }

  onOtpChange(event: any) {
    this.otp = event;
    if (this.otp.length != 6) {
      this.changeOtpBtn.nativeElement.disabled = true;
    } else {
      this.changeOtpBtn.nativeElement.disabled = ""
    }
    this.ResetsetOpt = false;
  }

  verifyOtp() {
    this.loader.showSpinner();
    this.loginInfo['login_id'] = this.forgotPasswordForm.value.mob;
    this.loginInfo['name'] = this.forgotPasswordForm.value.user_name;
    this.loginInfo['type'] = this.forgotPasswordForm.value.email;
    this.loginInfo['password'] = this.otp;
    this.loginInfo['payment_user'] = true;
    this.loginInfo['account_url'] = this.forgotPasswordForm.value.account_id;
    let obj = { "otpLogin": true }
    this.loginInfo['extra_data'] = obj;
    var menuParser: any = false;
    try {
      if (this.appService._appData.DECORATOR_DEF['menuParseDecorator'] != undefined) {
        menuParser = new this.appService._appData.DECORATOR_DEF['menuParseDecorator']();
      }
    } catch (e) {
      console.warn(e)
    }
    var loginInfo = this.loginService.encrypt(JSON.parse(JSON.stringify(this.loginInfo)));
    this.baseService.add(loginInfo, 'login').subscribe(
      (data: any) => {
        this.submitted = false;
        if (data.errCode == -1) {
          this.alertService.error(data.message);
          this.loader.hideSpinner();
        }
        else {
          if (data.resource != undefined && data.resource.length) {
            let newData = this.loginService.decryptLoginInfo(data);
            this.loginService.buildApplication(newData, menuParser);
          } else {
            this.alertService.error(data.message);
            this.loader.hideSpinner();
          }
        }
      });
  }

  searchResult(event) {
    if (this.patientData.length > 0) {
      this.patientData.pop()
    }
    this.patientData.push(event);
    localStorage.setItem('facility_id', this.patientData[0].facility_id)
  }

  onMakePayment() {
    let obj = {
      action: {
        "action": "popup_form",
        "action_name": "online_payment",
        "api_action": "get",
        "resource": "billing_details",
        "label": "button.pay_advance",
        "permission_required": true,
        "required_rowData": true,
        "decorator": "OnlinePayment",
        "dependent_fields2BindData": "id",
        "application": "billing",
        "form": {
          "ModalSize": "Sm",
          "blocks": [
            {
              "name": "basic_information",
              "class_name": "null",
              "order": 1,
              "fields": [
                {
                  "label": "Patient Due Amount",
                  "class_name": "kx-control col-sm-12 fix",
                  "order": 2,
                  "type": "decimal_currency",
                  "required": true,
                  "component": "numberbox",
                  "name": "patient_due_amount"

                },
                {
                  "type": "string",
                  "component": "hidden",
                  "name": "id"
                },
                {
                  "type": "string",
                  "component": "hidden",
                  "name": "facility_id"
                },
                {
                  "type": "string",
                  "component": "hidden",
                  "name": "uhId"
                },
                {
                  "type": "string",
                  "component": "hidden",
                  "name": "admissionId"
                }
              ],
              "title": ""
            }
          ]
        }
      },
      val: this.patientData[0]
    }
    this.smartModalService.open(DynamicPopUpComponent, obj, obj.action['title'], 'lg').pipe(take(1)).subscribe(res => {
      if (res) {

      }
    },
      err => {
        console.log("err");
      }
    );


    // sessionStorage.setItem("currentData", JSON.stringify(this.patientData[0]));
    // let args = "facility_id:" + this.patientData[0].facility_id +
    //   ",uhId:" + this.patientData[0].uhId +
    //   ",admissionId:" + this.patientData[0].admissionId;
    // this.baseService.get("VALIDATE_ADVANCE_FOR_PATIENT_ONLINE", args, "deposit", "payment").subscribe((res) => {
    //   if (res && res.resource && res.resource.length == 0) {
    //     let keyForUrl = this.patientData[0].id;
    //     this.bannerJson = {
    //       "selector": "app-patient-layout",
    //       "datasource": {
    //         "application": "patient-registration",
    //         "resource": "patient",
    //         "query_id": "GET_BY_ID"
    //       }
    //     }
    //     let key_banner = JSON.stringify(this.bannerJson)
    //     let url = 'order/' + this.patientData[0].facility_id + '/patient_pending_order/review';
    //     this.dialogRef.close();
    //     this.router.navigate([url], { queryParams: { returnUrl: window.location.pathname, key: keyForUrl, banner: key_banner } });
    //     sessionStorage.setItem('facility_id', this.patientData[0].facility_id);
    //   }
    //   else {
    //     if (res.errCode == -1) {
    //       this.alertService.error(res.message);
    //     }
    //   }
    // })
  }

  timerFn() {
    let localTime = localStorage.getItem('expiryTime')
    if (localTime) {
      this.sessionTimer = Number(localTime);
    }
    else {
      this.sessionTimer = 60 * 15
      localStorage.setItem('expiryTime', this.sessionTimer.toString())
    }
    let timerInterval = setInterval(() => {
      this.sessionTimer -= 1;
      localStorage.setItem('expiryTime', this.sessionTimer.toString())
      if (this.sessionTimer <= 0) {
        clearInterval(timerInterval);
        this.logout()
        localStorage.removeItem('expiryTime')
        localStorage.removeItem('facility_id')
      }
    }, 1000)
  }

  get minutes(): string {
    return Math.floor(this.sessionTimer / 60).toString().padStart(2, '0');
  }

  get seconds(): string {
    return (this.sessionTimer % 60).toString().padStart(2, '0');
  }

  logout() {
    this.loader.showSpinner();
    this.baseService.action({ notification_id: localStorage.getItem("notificationId") }, "", this.appService._appData.DEFAULT_APPLICATION, "logout").subscribe(
      (data: any) => {
        if (data.errCode == -1) {
          this.alertService.error(data.message);
        } else {
          this.storageService.reloadOtherTab();
          this.logoutSuccess();
        }
        this.loader.hideSpinner();
      }, error => {
        this.loader.hideSpinner();
        this.alertService.error('API error');
      }
    );
  }


  logoutSuccess() {
    this.auth.logout(() => {
      if (this.appService._initialRouteConfig) {
        this.router.resetConfig(this.appService._initialRouteConfig);
      }
      if (this.appService._appData.SUPER_APP != undefined) {
        let url = window.location.origin + "/" + this.appService._appData.DEFAULT_APPLICATION + "/login";
        console.log("login url --> ", url);
        this.baseService.redirect(url, "_self").then(() => {
        });
      } else {
        this.baseService.redirectToLogin();
      }
    });
  }

  backToForgotPass() {
    this.showOtpComponent = false;
  }

  backToReset() {
    this.show = false;
  }

  navigateToLogin() {
    console.log('forgot password clicked');
    this.router.navigate(['/login']);
  }

  showPaymentPopUp(data: any) {
    const config: ModalOptions = {
      backdrop: 'static',
      keyboard: false,
      animated: true,
      ignoreBackdropClick: true,
      initialState: {
        data: data
      }
    };
    this.modal.show(PaymentStatusComponent, config);
  }
}